<!--
  Generated template for the WelcomePage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-content fullscreen no-bounce class="tutorial-page">
    <ion-slides pager>
        <ion-slide class="p3" [style.background-image]="'url(/assets/imgs/tutorial/restyle/1.png)'">
            <ion-toolbar>
                <ion-buttons start>
                    <button ion-button (click)="skip()">{{'GLOBAL_SKIP' | translate}}</button>
                </ion-buttons>
            </ion-toolbar>
        </ion-slide>
        <ion-slide class="p3" [style.background-image]="'url(/assets/imgs/tutorial/restyle/2.png)'">
            <ion-toolbar>
                <ion-buttons start>
                    <button ion-button color="white" (click)="skip()">{{'GLOBAL_SKIP' | translate}}</button>
                </ion-buttons>
            </ion-toolbar>
        </ion-slide>

        <ion-slide class="p3" [style.background-image]="'url(/assets/imgs/tutorial/restyle/3.png)'">
            <ion-toolbar>
                <ion-buttons start>
                    <button ion-button color="white" (click)="skip()">{{'GLOBAL_SKIP' | translate}}</button>
                </ion-buttons>
            </ion-toolbar>
        </ion-slide>
        <ion-slide class="p3" [style.background-image]="'url(/assets/imgs/tutorial/restyle/4.png)'">
            <ion-toolbar>
                <ion-buttons start>
                    <button ion-button color="white" (click)="skip()">{{'GLOBAL_SKIP' | translate}}</button>
                </ion-buttons>
            </ion-toolbar>
        </ion-slide>
    </ion-slides>
</ion-content>